<div class="app-bg scroll-fix">

    <div class="container container-padding">


        <h1 class="page-header">{{ 'OFFER_CONFIG.HEADER' | translate : {number: (offer$ | async).number} }}</h1>

        <app-alert alertType="info" *ngIf="flag?.active === false">
            {{ 'SCHEDULE.APPLICATION_IS_NOT_ACTIVE' | translate }}
        </app-alert>

        <div class="separator"></div>

        <app-clients-box [offer]="offer$ | async"
                         [readonly]="readonly">
        </app-clients-box>

        <div class="separator"></div>

        <app-property-box [offer]="offer$ | async"
                          [readonly]="readonly">
        </app-property-box>

        <div class="separator"></div>

        <app-motor-box [offer]="offer$ | async"
                       [readonly]="readonly">
        </app-motor-box>

        <div class="separator"></div>

        <div class="box mt-5" *ngIf="(offer$ | async).premium !== null">
            <div class="box-body">
                <div class="row">
                    <div class="col"></div>
                    <div class="col-size">
                        <div class="text-price">
                            <div class="item-text">{{'OFFER_CONFIG.TOTAL_PREMIUM' | translate}}</div>
                            <div class="item-price">{{ (offer$ | async).premium | premium }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <hr class="dimmed mt-5">

        <div class="row" *ngIf="(offer$ | async).summaryStepEnabled">
            <div class="col"></div>
            <div class="col-auto">
                <button [routerLink]="['/calculation', (offer$ | async).id, 'summary']"
                        class="btn btn-primary">
                    {{ 'BUTTON.GO_TO_SUMMARY' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

